import { render, staticRenderFns } from "./VtexPricingJob.vue?vue&type=template&id=67492d36&"
import script from "./VtexPricingJob.vue?vue&type=script&lang=js&"
export * from "./VtexPricingJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports